<template>
    <div class="container mx-auto px-4"
         v-if="sessionStore.user && sessionStore.user.role === 'admin'"
    >
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">{{ __('Beállítások') }}</h1>

        <h2 class="font-serif mb-4 text-center text-xl">{{ __('Szalaghirdetés') }}</h2>

        <c-control-text class="mx-auto w-96" class-field="bg-white border-b border-highlight h-auto py-2 !text-base" class-label="mb-2" name="banner_text" type="textarea"
                        v-bind:invalid="!!requestStore.errors?.banner_text"
                        v-bind:label="__('Szöveg (üresen hagyva a szalag nem jelenik meg)')"
                        v-bind:rows="3"
                        v-model="settings.banner_text"
        />

        <div class="mt-8 mx-auto w-96">
            <label class="block mb-2">{{ __('Háttérszín') }}</label>

            <div class="flex items-center">
                <input class="border border-slate-200 cursor-pointer h-10 mr-4 rounded w-16" type="color"
                       v-model="settings.banner_color"
                />

                <c-control-text class="flex-1" class-field="bg-white border-b border-highlight h-auto py-2 !text-base" name="banner_color" placeholder="#f59e0b"
                                v-bind:invalid="!!requestStore.errors?.banner_color"
                                v-model="settings.banner_color"
                />
            </div>
        </div>

        <c-button class="bg-slate-800 border-2 border-slate-800 font-semibold hover:bg-highlight hover:border-highlight mb-4 mt-8 mx-auto normal-case px-4 py-2 rounded-none table text-center !text-lg text-white transition-colors w-48"
                  v-on:click="submit"
        >
            {{ __('Mentés') }}
        </c-button>
    </div>
</template>

<script setup lang="ts">
    import { inject, onMounted, ref } from 'vue';
    import {
        CButton,
        CControlText,
    } from '@teamfurther/cinderblock';
    import SettingRepository from '../../repositories/SettingRepository';
    import { useBannerStore } from '../../stores/banner';
    import { useRequestStore } from '../../stores/request';
    import { useSessionStore } from '../../stores/session';

    const __ = inject('__');
    const bannerStore = useBannerStore();
    const requestStore = useRequestStore();
    const sessionStore = useSessionStore();
    const settingRepository = new SettingRepository();
    const settings = ref({
        banner_color: '#f59e0b',
        banner_text: '',
    });

    async function submit() {
        settings.value = await settingRepository.update(settings.value);

        await bannerStore.fetch();
    }

    onMounted(async () => {
        settings.value = await settingRepository.index();
    });
</script>
